import { connect } from 'react-redux';
import React from 'react';
import PresentationComponent from '../../../components/dashboards/tabcomponents/TemplateDrawerMenu';
import EventTemplateDrawer from './EventTemplateDrawer';

const mapStateToProps = () => ({
  templateDrawer: (collapsed, setCollapsed) => (
    <EventTemplateDrawer collapsed={collapsed} setCollapsed={setCollapsed} />
  ),
});

const EventsTemplatesDrawer = connect(mapStateToProps, null)(PresentationComponent);

export default EventsTemplatesDrawer;
